import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from "react-router-dom";
import LogoComponent from './LogoComponent';
import { ReactComponent as LeftArrow } from 'assets/back-btn.svg';
import { headerConfigurableType } from 'frontend_common/HeaderConfig';
import GreetingComponent from './GreetingComponent';
import WelcomeComponent from './WelcomeComponent';
import PointWithCashComponent from './PointWithCashComponent';
import CustomLeftComponent from './CustomLeftComponent';
import { showBackButtonInNavigatorBar } from 'utils/UIConfigUtils'

const showBackButtonPath = [
  '/coupon/',
  '/use_coupon',
  '/campaign/',
  '/inboxDetail/',
  '/level_rule',
  '/level_benefit',
  '/reward_status',
  '/activity_log',
  '/transaction_history',
  '/transactionDetail',
  '/transaction/create',
  '/use_cash_dollar',
];

const getShowBackButton = (location) => {
  let showBackButton = false;
  showBackButtonPath.forEach(item => {
    if (location.pathname.indexOf(item) !== -1) {
      showBackButton = true;
    };
  });

  return showBackButton;
};

const LeftComponent = ({
  language,
  backBtnAction,
  navBarConfig,
  isMobile,
}) => {
  const location = useLocation();
  const history = useHistory();

  const showBackButton = useMemo(() => (
    getShowBackButton(location)
  ), [location])

  const backToHome = useMemo(() => (
    location.state?.backToHome
  ), [location.state])

  const simplifiedShowBackButton = showBackButtonInNavigatorBar()

  if (!isMobile) {
    return <LogoComponent />
  }

  if (showBackButton) {
    if (!simplifiedShowBackButton) {
      return null
    }
    return (
      <div
        className='header-back-btn-container'
        onClick={() => {
          if (backBtnAction && typeof backBtnAction === 'function') {
            backBtnAction();
          } else if (backToHome) {
            history.push('/home');
          } else if (!location.key) {
            history.push('/home');
          } else {
            history.goBack();
          }
        }}
      >
        <LeftArrow className='header-back-btn' />
      </div>
    )
  }

  if (navBarConfig.type === headerConfigurableType.greetingWithName) {
    return <GreetingComponent />
  }

  if (navBarConfig.type === headerConfigurableType.welcomeMessage) {
    return <WelcomeComponent navBarConfig={navBarConfig} />
  };

  if (navBarConfig.type === headerConfigurableType.pointWithCash) {
    return <PointWithCashComponent />
  };

  if (navBarConfig.type === headerConfigurableType.custom) {
    return <CustomLeftComponent navBarConfig={navBarConfig} />;
  }

  if (navBarConfig.type === headerConfigurableType.none) {
    return null;
  }

  return <LogoComponent isMobile isCenter={navBarConfig.headerLogoCenter} />
};

const mapStateToProps = (state) => ({
  language: state.users.language,
  backBtnAction: state.navBars.backBtnAction,
});

export default connect(mapStateToProps)(LeftComponent);
